module.exports = __webpack_public_path__ + "img/shanchu@3x.94fd6d22.svg";